import getConsumerMailboxOptions from '../services/getConsumerMailboxOptions';
import { updateUserConfiguration } from 'owa-session-store/lib/actions/updateUserConfiguration';

export default async function loadConsumerMailboxOptions() {
    const options = await getConsumerMailboxOptions();
    if (options) {
        updateUserConfiguration(userConfig => {
            userConfig.SessionSettings.UserProxyAddresses = options.EmailAddresses;
            userConfig.SessionSettings.NotManagedEmailAddresses = options.NotManagedEmailAddresses;
        });
    }
}
